// extracted by mini-css-extract-plugin
module.exports = {"record-message":"record-message-de0b558c8acd2091f019a2e3dd77fb70"};